'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionsListStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  maxLines: _propTypes2.default.number,
  theme: _propTypes2.default.object
};
var defaultProps = {
  maxLines: 5
};

var style = function style(_ref) {
  var themeFromProvider = _ref.theme,
      maxLines = _ref.maxLines;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.inputAutocomplete.optionsList,
      backgroundColor = _theme$reactackle$com.backgroundColor,
      paddingY = _theme$reactackle$com.paddingY,
      paddingX = _theme$reactackle$com.paddingX,
      borderRadius = _theme$reactackle$com.borderRadius,
      minWidth = _theme$reactackle$com.minWidth,
      maxWidth = _theme$reactackle$com.maxWidth;
  var _theme$reactackle$com2 = theme.reactackle.components.inputAutocomplete.option,
      lineHeight = _theme$reactackle$com2.lineHeight,
      itemPaddingY = _theme$reactackle$com2.paddingY;
  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
  var py = (0, _reactackleCore.getValueString)(paddingY),
      itemPy = (0, _reactackleCore.getValueString)(itemPaddingY),
      textHeight = lineHeight * maxLines - 1;
  var maxHeight = 'calc(' + py + ' * 2 + ' + textHeight + 'em + ' + itemPy + ' * ' + 2 * maxLines + ')';
  return '\n    padding: ' + py + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n    background-color: ' + backgroundColor + ';\n    border-radius: ' + (0, _reactackleCore.getValueString)(borderRadius) + ';\n    max-height: ' + maxHeight + ';\n    width: 100%;\n    min-width: ' + (0, _reactackleCore.getValueString)(minWidth) + ';\n    max-width: ' + (0, _reactackleCore.getValueString)(maxWidth) + ';\n    animation: ' + _reactackleCore.animations.fadeInDownSmall + ' 150ms ease-in;\n    animation-fill-mode: both;\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
};

var OptionsListStyled = exports.OptionsListStyled = _styledComponents2.default.ul.withConfig({
  displayName: 'OptionsListStyled'
})(['margin:0;list-style-type:none;width:100%;overflow-y:auto;z-index:1;user-select:none;', ';', ';'], style, (0, _reactackleCore.boxShadow)(3));

OptionsListStyled.propTypes = propTypes;
OptionsListStyled.defaultProps = defaultProps;
OptionsListStyled.displayName = 'OptionsListStyled';